import React from "react";

import {
  Typography,
  Paper,
  FormControl,
  FormLabel,
  FormControlLabel,
  FormGroup,
  Checkbox
} from "@material-ui/core";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import {} from "@material-ui/core/colors";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      marginBottom: 10
    },
    formControl: {
      margin: theme.spacing(3)
    }
  })
);

export const IvTpaChecklist = () => {
  const classes = useStyles();

  const checkbox_options1 = [
    "Diagnosis of acute ischemic stroke (Determined to be disabling by patient and clinician; low NIHSS is not an exclusion for IV Alteplase)",
    "Patient is ≥ 18 years of age",
    "Stroke onset within 4.5 hrs of start of IV tPA",
    "No evidence of intracranial or subarachnoid hemorrhage on CT",
    "No symptoms suggestive of subarachnoid hemorrhage, even if CT is normal",
    "No frank hypodensity on CT (evidence supports the treatment of mild to moderate early ischemic changes)",
    "No prior stroke in previous 3 months",
    "No severe head trauma in previous 3 months",
    "No known presence of intracranial aneurysms ≥ 10mm, intraparenchymal neoplasms or arteriovenous malformations",
    "Blood pressure is controlled at time of treatment (i.e. ≤ 185 systolic AND < 110 diastolic)",
    "No recent history of intracranial hemorrhage",
    "No recent intracranial or intraspinal surgery within previous 3 months",
    "No arterial puncture at a non-compressible site within the previous 7 days",
    "No active internal bleeding",
    "No current use of the oral anticoagulant Warfarin (Coumadin) unless INR is ≤ 1.7",
    "No current use of direct thrombin inhibitors or direct factor Xa inhibitors (novel oral anticoagulants) - Dabigatran (Pradaxa), Rivaroxaban (Xarelto), Apixaban (Eliquis), Edoxaban (savaysa). May consider if > 48 hours from last dose and normal renal function",
    "No Low Molecular Weight Heparin (ex. Lovenox, Arixtra) administration within the past 24 hours",
    "No unfractionated heparin administration within the past 48 hours unless aPTT has returned to within normal range.",
    "Platelet count is ≥ 100,000/mm³ (If results pending, do not delay IV Alteplase)"
  ];

  const checkbox_options2 = [
    "Pregnancy",
    "< 14 days Postpartum",
    "Seizure at onset of stroke if residual impairments are deemed postictal and not secondary to stroke",
    "Major surgery or serious trauma (within previous 14 days)",
    "Recent gastrointestinal or urinary tract hemorrhage (within the previous 21 days)",
    "Recent acute myocardial infarction (within previous 3 months)",
    "History of a bleeding disorder",
    "Acute Pericarditis ",
    "Potential risks and benefits of IV tPA treatment discussed with patient and/or family members and they have verbalized understanding"
  ];
  return (
    <>
      <Typography variant="h3">IV tPA Screening Checklist</Typography>
      <Paper className={classes.paper}>
        <FormControl component="fieldset" className={classes.formControl}>
          <FormLabel component="legend">
            This Inclusion/Exclusion Criteria Checklist is a tool to be used in
            the assessment of a patient in the acute setting. The final decision
            to use or not to use IV tPA is at the discretion of the treating
            physician.
          </FormLabel>
          <FormGroup>
            {checkbox_options1.map(item => {
              return (
                <FormControlLabel
                  control={<Checkbox name={item} />}
                  label={item}
                />
              );
            })}
          </FormGroup>
        </FormControl>
      </Paper>
      <Paper className={classes.paper}>
      <Typography variant="h5">
      If any items in this section are checked, ensure Neurologist is aware. These do not exclude patient from IV tPA but do necessitate careful consideration prior to IV tPA administration
      </Typography>
      <FormControl component="fieldset" className={classes.formControl}>
          <FormLabel component="legend">
          RELATIVE Exclusion Criteria – recent experience suggests that under
          some circumstances - with careful consideration & weighting of risk to
          benefit- patients may receive fibrinolytic therapy despite 1 or more
          of these relative contraindications.
          </FormLabel>
          <FormGroup>
            {checkbox_options2.map(item => {
              return (
                <FormControlLabel
                  control={<Checkbox name={item} />}
                  label={item}
                />
              );
            })}
          </FormGroup>
        </FormControl>
      </Paper>
    </>
  );
};
